import { TON_ADDRESS_PREVIEW } from "../../constants/walletAssociation.constants";

export const shortenTonAddress = (address: string): string =>
  `${address.slice(0, TON_ADDRESS_PREVIEW.HEAD)}...${address.slice(
    -TON_ADDRESS_PREVIEW.TAIL
  )}`;
